import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	projects: {
		total: 0,
		results: [],
		isLoading: false,
		hasBeenLoaded: false,
		error: ''
	}
};

export const projectsSlice = createSlice({
	name: 'projects',
	initialState,
	reducers: {
		getProjects: (state) => {
			state.projects.isLoading = true;
		},
		getProjectsCompleted: (state, action) => {
			state.projects.isLoading = false;
			state.projects.total = action.payload.count;
			state.projects.results = action.payload.results;
			state.projects.hasBeenLoaded = true;
			state.projects.error = '';
		},
		getProjectsFailed: (state, action) => {
			state.projects.isLoading = false;
			state.projects.hasBeenLoaded = false;
			state.projects.error = action.payload;
		}
	}
});

export const { getProjects, getProjectsCompleted, getProjectsFailed } =
	projectsSlice.actions;

export default projectsSlice.reducer;
